import { format } from 'date-fns';

// cn is shared: all four apps had a byte-identical copy. Re-exported rather than
// moved so existing `from '@/lib/utils'` import sites do not change.
export { cn } from '@loomlite/utils';

export function formatDate(iso: string | null | undefined): string {
	if (!iso) return '';
	try {
		return format(new Date(iso), 'MMM d, yyyy p');
	} catch {
		return iso;
	}
}
